import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const SalesRepBarChart = ({ data, formatINR }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          <p className="text-xs text-muted-foreground">Deals: {payload?.[0]?.value}</p>
          <p className="text-xs text-muted-foreground">Revenue: {formatINR(payload?.[1]?.value)}</p>
        </div>
      );
    }
    return null;
  };

  const formatYAxis = (value) => {
    return `₹${(value / 1000000)?.toFixed(0)}M`;
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-foreground mb-1">Sales Rep Performance</h3>
        <p className="text-sm text-muted-foreground">Individual performance by deals and revenue</p>
      </div>
      <div className="h-[300px] md:h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" opacity={0.5} />
            <XAxis
              dataKey="name"
              stroke="#64748B"
              style={{ fontSize: '11px' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis
              yAxisId="left"
              stroke="#64748B"
              style={{ fontSize: '12px' }}
              label={{ value: 'Deals', angle: -90, position: 'insideLeft', style: { fontSize: '12px' } }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="#64748B"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
              label={{ value: 'Revenue', angle: 90, position: 'insideRight', style: { fontSize: '12px' } }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '14px', paddingTop: '10px' }}
              iconType="rect"
            />
            <Bar
              yAxisId="left"
              dataKey="deals"
              fill="#8B7EC8"
              radius={[8, 8, 0, 0]}
              name="Deals"
            />
            <Bar
              yAxisId="right"
              dataKey="revenue"
              fill="#9AE6B4"
              radius={[8, 8, 0, 0]}
              name="Revenue"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SalesRepBarChart;